import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import toast from 'react-hot-toast';

const EditTaskModal = ({ show, onHide, task, onUpdate, apiUrl }) => {
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    task: '',
    deadline: '',
    priority: '',
  });

  useEffect(() => {

    if (task) {
      setFormData({
        task: task.task || '',
        deadline: task.deadline ? new Date(task.deadline).toISOString().split('T')[0] : '',
        priority: task.priority || '',
      });
    }
  }, [task]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const updatedTask = {
        task: formData.task,
        deadline: formData.deadline ? new Date(formData.deadline) : null,
        priority: formData.priority,
      };
      const response = await axios.put(`${apiUrl}/update/${task._id}`, updatedTask, {
        withCredentials: true,
      });
      toast.success("Task update successfully!");
      onUpdate(response.data.task);
      onHide();
    } catch (err) {
      console.error('Failed to update task:', err);
      alert('Error updating task');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Task</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formTask">
            <Form.Label>Task</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="task"
              value={formData.task}
              onChange={handleInputChange}
              placeholder="Enter task description"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formDeadline">
            <Form.Label>Due Date</Form.Label>
            <Form.Control
              type="date"
              name="deadline"
              value={formData.deadline}
              onChange={handleInputChange}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formPriority">
            <Form.Label>Priority</Form.Label>
            <Form.Select
              name="priority"
              value={formData.priority}
              onChange={handleInputChange}
              required
            >
              <option value="">Select priority</option>
              <option value="High">High</option>
              <option value="Medium">Medium</option>
              <option value="Low">Low</option>
            </Form.Select>
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button variant="primary" type="submit" disabled={saving} onClick={handleSubmit}>
              {saving ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  Saving...
                </>
              ) : (
                'Save Changes'
              )}
            </Button>
          </div>

        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditTaskModal;
